import TeacherEditAudit from './src/main';

/* istanbul ignore next */
TeacherEditAudit.install = function(Vue) {
  Vue.component(TeacherEditAudit.name, TeacherEditAudit);
};

export default TeacherEditAudit;
